import { Link } from "react-router-dom"

function HostExperience() {
  return (
    <>
    <section className="ser_v_araeea allpages dashboardpgs Calender">
     <div className="container">   
	   <div className="calenddres">
		<div className="td_upcmings">
		 <a href="#" className="actcler">Today</a>
		 <a href="#">Upcoming</a>
		</div>
		
		<div className="btm_ar_contents td_upcmings">
		 <h4>You don’t have any reservations</h4>
		 <p>Your experience won’t appear in search results and can’t be booked. Relist to start earning.</p>
		 <Link to={'/listing'}>Go to listings</Link>
		</div>
		
	   </div>
	   
	   
	 </div>
	</section> 
    </>
  )
}

export default HostExperience